module.exports = __webpack_public_path__ + "static/react-themes-ecommerce-0a012bb5c9cc6be4d811503de7a693d2.jpg";